import { Provider } from 'react-redux';
import { useState, useEffect } from 'react';
import AppRouter from './routers/AppRouter';
import { store, persistor } from "./utilities/store";
import { PersistGate } from "redux-persist/integration/react";

const App = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    // Check current installation status
    const checkInstallation = () => {
      const displayMode = window.matchMedia('(display-mode: standalone)').matches;
      const iosStandalone = window.navigator.standalone === true;
      return displayMode || iosStandalone;
    };

    setIsInstalled(checkInstallation());

    // Listen for PWA install prompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Only show install button if not already installed
      if (!checkInstallation()) {
        setShowInstallButton(true);
      }
    };

    // Listen for successful installation
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setDeferredPrompt(null);
      setShowInstallButton(false);
    };

    // Add event listeners
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppRouter 
          deferredPrompt={deferredPrompt}
          isInstalled={isInstalled}
          showInstallButton={showInstallButton}
        />
      </PersistGate>
    </Provider>
  );
};

export default App;